module.exports = __webpack_public_path__ + "img/operationFailure.c565652b.png";